import { ReactElement } from 'react';
import * as React from 'react';
import dynamic from 'next/dynamic';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Header from 'shared/components/Header';
import { Footer } from '@zoopla/footer';
import ConsentBanner from 'shared/components/ConsentBanner';
import AdScripts from '../AdScripts';

const StyledHeader = styled('header')(
    (props) => css`
        @media only screen and (min-width: ${props.theme.breakpoints[2]}px) {
            box-shadow: ${props.theme.boxShadow['100']};
        }
    `
);
const GoogleOneTap = dynamic<Record<string, unknown>>(
    () =>
        import('@zoopla/authentication/modal').then(
            (module) => module.GoogleOneTap
        ),
    {
        ssr: false
    }
);

const MainScript = dynamic(() => import('shared/components/main'), {
    ssr: false
});

/**
 * Default layout used across site, includes web chrome i.e header, footer etc
 */
export const Layout: React.FC = ({ children }) => (
    <>
        <AdScripts />
        <StyledHeader>
            <Header />
        </StyledHeader>
        <ConsentBanner />
        <MainScript />
        {children}
        <GoogleOneTap />
        <Footer />
    </>
);

/**
 * Default getLayout function used if not defined on the Page component.
 * @see {Layout}
 */
export const getWebChromeLayout = (page: ReactElement): ReactElement => (
    <Layout>{page}</Layout>
);
